import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase.js';
import { useAuth } from './auth.jsx';
import { resolveTier, TIER_PILOT } from './tiers.js';

// useTier — returns the current vendor's tier config + raw planTier string.
//
// Reads vendors/{vendorId} via onSnapshot so tier changes propagate live (useful
// once we wire upgrade/downgrade flows in PRICING C). Until then, planTier is
// effectively static ('pilot' from signup).
//
// Default tier is 'pilot' (all features unlocked, no caps) — preserves current
// no-enforcement behavior. PRICING B + C will introduce actual gating.
//
// Returns: { tier, planTier, loading }

export function useTier() {
  const { claims } = useAuth();
  const vendorId = claims?.vendor_id;

  const [planTier, setPlanTier] = useState('pilot');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!vendorId) {
      setLoading(false);
      return;
    }
    const unsub = onSnapshot(
      doc(db, 'vendors', vendorId),
      (snap) => {
        const data = snap.exists() ? snap.data() : null;
        setPlanTier(data?.planTier || 'pilot');
        setLoading(false);
      },
      () => setLoading(false), // permission errors → fall back to pilot
    );
    return () => unsub();
  }, [vendorId]);

  return {
    tier: resolveTier(planTier) || TIER_PILOT,
    planTier,
    loading,
  };
}
